import { render, staticRenderFns } from "./WantToExtendTerm.vue?vue&type=template&id=c1b68e0c&scoped=true"
import script from "./WantToExtendTerm.vue?vue&type=script&lang=js"
export * from "./WantToExtendTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b68e0c",
  null
  
)

export default component.exports